module.exports = __webpack_public_path__ + "img/card_230290669.422380cf.jpg";